type Input = {
  [key: string]: any;
};

const unflatten = (input: Input, splitter?: string) => {
  let key, parts, t;
  if (splitter == null) {
    splitter = '__';
  }
  const output: { [key: string]: any } = {};
  for (const k in input) {
    t = output;
    parts = k.split(splitter);
    key = parts.pop() || '';
    while (parts.length) {
      const part = parts.shift() || '';
      t = t[part] = t[part] || {};
    }
    t[key] = input[k];
  }
  return output;
};

export default unflatten;
